module.exports = __webpack_public_path__ + "static/media/loginWithLogo.5e813836.svg";